import React from 'react';
import {useSelector} from 'react-redux';
import ZJ from '../images/ZJ.png';
import Loader from '../components/Loader';

import LanguageContext from '../contexts/contexts';
import GlobalFilter from '../components/GlobalFilter';
/*
   @header 
      ID / payment / modal

   toggle button [ input <=> approve] 

   @submit  area (the user check and submit data)
   @approve area (check and approve)

   @[ backward next ]
*/
const EpartsCard = ()=>{

     const {language} = React.useContext(LanguageContext);
     
     const [loading,setLoading] = React.useState(false);

     const {userInfo} = useSelector(state=>state.userLogin);


     /*
      
                        <img 
                           src = {ZJ} 
                           width ='100'
                           alt = 'ZJ'  
                        />
                        {/* <span className ='ml-3'>
                           <img 
                                 src = {ZJ} 
                                 width ='80'
                                 alt = 'ZJ'  
                           />

                        </span> 
                        
                        <span className ='ml-3 text-dark display-5'>
                           <b style = {{fontSize:'125%'}}>{language === 'en' ? ''.toUpperCase() :''}</b>
                        </span>
                  

     */

     return (
      <>

     <div className ='mx-auto'>
            <GlobalFilter
               //  preGlobalFilteredRows={preGlobalFilteredRows} 
               //  globalFilter={globalFilter || {}} 
               //  setGlobalFilter={setGlobalFilter || ()=>{}}
                language={language}
            />
      </div>
      
      <section>
         <div className = 'row text-center mt-4' >
            <span className ='mx-auto'>

               {loading ? (<Loader />) :(<></>)}
               
            </span>
         </div>

          {
             userInfo?.role_type && userInfo.role_type === 'VENDOR' ? (

               <div>产品登记...</div>

             ) :(
             <div 
               style ={{
                  marginTop:'5vh',
                  minHeight:'150px',
                  backgroundImage:'url('+require('../images/pallet.jpg')+')',
                  backgroundPosition: 'center',
                  backgroundSize: '70%',
                  backgroundRepeat: 'no-repeat',
               }}>
              ...
              </div>
             )
          }
     



      </section>
      </>
     );
};

export default EpartsCard;
